import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { IP } from "../config/IP";
import store from "../store/createStore";

export const useFetch = (query) => {
	console.log("In  fetchData function query=", query);
	const [state, setState] = useState({
		data: null,
		file: null,
		loading: true,
		signature: null,
	});
	const token = localStorage.getItem("token");

	const currentstate = store.getState();
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	async function fetchData(query) {
		let inquery = "";
		if (query.id) {
			inquery = {
				id: query.id,
				companyId: query.companyId,
				office_id: query.office_id,
				actingOffices: query.actingOffices,
				assistant_offices:query.assistant_offices,
				page: query.page,
				limit: query.limit,
			};
		} else if (query.office_id) {
			inquery = {
				companyId: query.companyId,
				office_id: query.office_id,
				actingOffices: query.actingOffices,
				assistant_offices:query.assistant_offices,
				page: query.page,
				limit: query.limit,
			};
		}

		let response = await axios
			.post(IP.nodeServer + "api/getDocs", inquery, config)
			.then((response) => {
				if (response.data) {
					console.log("axios DocId=", query);
					console.log("axios response=", response);
					let doclist = response.data;
					let docsin = [];
					let respCondition = false;

					let data = [];
					let files = [response.data.file];
					let signature = response.data.signature;
					let direction;
					console.log("doclist=", doclist);
					doclist.docs.map((doclist) => {
						if (!doclist.Doc_Name) {
							respCondition = true;
						}
						if (doclist.currentSituation.direction == 1) {
							direction = <ArrowUpwardIcon />;
						} else if (doclist.currentSituation.direction == -1) {
							direction = <ArrowDownwardIcon />;
						} else {
							direction = "";
						}

						data.push({
							DocName: doclist.DocName,
							DocType: doclist.DocType,
							OwnerOffice: doclist.office_id,
							DocTypeDescription: currentstate.loadRoutes.docType.filter(
								(x) => x.Doc_type_id === parseInt(doclist.DocType)
							)[0].name,

							currentOfficeLocation:
								doclist.currentSituation.currentOfficeLocation,

							currentOfficeLocationName: currentstate.auth.user.allOffices.filter(
								(x) =>
									x.office_id === doclist.currentSituation.currentOfficeLocation
							)[0].office_name,
							direction: direction,
							status: doclist.currentSituation.status,
							statusDescription: doclist.currentSituation.statusDescription,
							statusDate: doclist.currentSituation.statusDate,
							action: currentstate.auth.user.settings[0].action.filter(
								(x) => x.id == parseInt(doclist.currentSituation.action)
							)[0].actionDescription,
							actionDate: doclist.currentSituation.actionDate,
							id: doclist._id,
							share: doclist.share ? doclist.share : [],
							comments: doclist.comments,
							StepProgress: doclist.StepProgress,
							historySituation: doclist.historySituation,
							deleteDisabled: true,
						});
					});
					docsin = {
						title: "Available Documents",
						columns: [
							{ title: "DocName", field: "DocName" },
							{ title: "DocTypeDescription", field: "DocTypeDescription" },
							{
								title: "currentOfficeLocationName",
								field: "currentOfficeLocationName",
							},
							{ title: "direction", field: "direction" },
							{ title: "statusDescription", field: "statusDescription" },
							{ title: "statusDate", field: "statusDate" },
							{ title: "action", field: "action" },
							{ title: "actionDate", field: "actionDate" },
							{ title: "id", field: "id" },
						],
						data: data,
					};
					console.log("fetchData docsin=", docsin);

					setState({
						data: docsin,
						files: files,
						loading: false,
						signature: signature,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
				}
			})
			.catch((error) => {
				console.log("fetchData error=", error);
				setState({ ...state, loading: false });
			});
		return () => {
			console.log("unmount useFetch");
		};
	}
	useEffect(() => {
		fetchData(query);
	}, [query.id, query.office_id, query.limit, query.page]);
	return { ...state, fetchData: fetchData };
};
